module.exports = __webpack_public_path__ + "assets/987b2598a2640608b04f901b2186d502.mp4";